const formatDate = (date) => {
  return new Date(date).toString().slice(0, 21);
};

// eslint-disable-next-line import/prefer-default-export
export { formatDate };
